import { ExtranetProductShortageOrderDto } from '@pharmac-extranet/extranet-api'
import {
  ExtranetContainer,
  ExtranetTable,
  ExtranetTableColumn,
  ExtranetTableRow,
  useBreakpoint,
  useLanguage,
} from '@pharmac-extranet/shared'
import { PharmacIcon, PharmacText, PharmacTooltip } from '@pharmac/ui'
import { ProductShortagesCustomerRow } from './ProductShortagesCustomerRow'

type Props = {
  orders: ExtranetProductShortageOrderDto[]
}

export const ProductShortageTable = ({ orders }: Props) => {
  const { t } = useLanguage(['extranet'])
  const { minDesktop } = useBreakpoint()

  return (
    <ExtranetTable style={{ fontFamily: 'var(--font-family-secondary)', fontWeight: 300 }}>
      {minDesktop && (
        <ExtranetTableRow
          noBorders
          noMargin
          style={{
            backgroundColor: 'var(--extranet-light-purple)',
            border: 'none',
            fontWeight: 400,
          }}
        >
          <ExtranetTableColumn
            marginSmallLeft
            size={1.4}
          >
            {t('orderHistory.name')}
          </ExtranetTableColumn>
          <ExtranetTableColumn size={0.8}>{t('orderHistory.dateOfBirth')}</ExtranetTableColumn>
          <ExtranetTableColumn
            size={1.4}
            style={{ overflow: 'visible' }}
          >
            <ExtranetContainer
              flexRow
              alignCenter
            >
              {t('orderHistory.subscriptionPeriod')}
              <PharmacTooltip
                marginSmallLeft
                position="right"
                handle={
                  <PharmacIcon
                    style={{ color: 'var(--color-info)' }}
                    size="20px"
                    icon="info"
                  />
                }
              >
                <PharmacText>{t('productShortages.subscriptionPeriodInfo')}</PharmacText>
              </PharmacTooltip>
            </ExtranetContainer>
          </ExtranetTableColumn>
          <ExtranetTableColumn size={1.4}>
            {t('productShortages.replaceableProduct')}
          </ExtranetTableColumn>
          <ExtranetTableColumn size={0.9} />
          <ExtranetTableColumn size={1}>{t('medicines.availableForCustomers')}</ExtranetTableColumn>
          <ExtranetTableColumn size={1.2}>{t('medicines.substituteProduct')}</ExtranetTableColumn>
          <ExtranetTableColumn size={0.6} />
        </ExtranetTableRow>
      )}
      {orders.map((a) => (
        <ProductShortagesCustomerRow
          key={a.id}
          order={a}
        />
      ))}
    </ExtranetTable>
  )
}
